import { GetServerSidePropsContext } from "next";
import { SWRConfig } from "swr";

import Bugsnag from "@bugsnag/js";

import EntityPageContainer from "components/EntityPageLayout";
import { entityLayoutData } from "components/EntityPageLayout/entityLayoutData";
import EntityPageData from "components/EntityPageLayout/EntityPageData";
import type { NextPageWithLayout } from "pages/_app";

const EntityDataTabPage: NextPageWithLayout = () => {
  return <EntityPageData />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const slug = context.params?.slug as string;

    const { entity, entityLayoutFallback } = await entityLayoutData(
      slug,
      context
    );

    if (!entity || entity.errors?.length) return { notFound: true };

    return {
      props: {
        slug,
        entity,
        fallback: entityLayoutFallback,
      },
    };
  } catch (error: any) {
    console.error(
      "[slug].tsx ~ getServerSideProps entity data Page ~ error",
      error
    );
    Bugsnag.notify(error);
    return { notFound: true };
  }
}

EntityDataTabPage.getLayout = (page, { pageProps }) => {
  const { fallback } = pageProps;

  return (
    <SWRConfig value={{ fallback }}>
      <EntityPageContainer {...pageProps}>{page}</EntityPageContainer>
    </SWRConfig>
  );
};

export default EntityDataTabPage;
